module.exports = __webpack_public_path__ + "static/media/sun.50cba4d7.jpg";